import React, { useState, useEffect } from 'react';
import { useTheme, TablePagination, Stack, Typography } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import TablePaginationActions from '../../../components/TablePaginationActions';
import { CancelToken } from 'apisauce';
import PageHeader from '../../../components/PageHeader';
import * as moment from 'moment';
import appapi from '../../../api/apiClient';
import { Box } from '@mui/system';
import Layout from '../../../components/Layout';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { setLoading } from '../../../redux/features/appSlice';
import { showmessage } from '../../../utils/toastr';
import TabLayout from '../../../components/TabLayout';
import { checkPermission } from '../../../redux/features/authSlice';
import Current from './TabPages/Current';
import Blocked from './TabPages/Blocked';
import AddEditCompany from './Components/AddEditCompany';
import ViewCompany from './Components/ViewCompany';
import AlertDialog from './Components/AlertDialog';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function CompanyManagement() {
  const theme = useTheme();
  let source = CancelToken.source();
  const [payload, setPayload] = useState({
    page: 1,
    limit: 10,
    filter: null,
    companyTypeFilter: null,
    screeningStatusFilter: null,
    entityTypeFilter: null,
    clientTypeFilter: null,
    totalLength: 0,
    paginationPage: 0,
    field: '_id',
    sortOrder: 'desc',
  });
  const [companyManagementList, setCompanyManagementList] = useState([]);
  const [openAddCompany, setOpenAddCompany] = useState(false);
  const [companyDetails, setCompanyDetails] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [openViewCompany, setOpenViewCompany] = useState(false);
  /**
   * retrieving user From Redux Store
   */
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);
  /**
*

  /**
 *
 * @function handleChangePage
 * @function handleChangeRowsPerPage
 * handle Pagination
 */
  const handleChangePage = (event, newPage) => {
    setPayload((prevState) => ({ ...prevState, page: newPage + 1, paginationPage: newPage, filter: payload.filter }));
  };

  const handleChangeRowsPerPage = (event) => {
    setPayload((prev) => ({ ...prev, limit: parseInt(event.target.value, 10), paginationPage: 1, page: 1, filter: payload.filter }));
  };

  //search filter
  const handleSearchEmit = (search) => {
    setPayload((prevState) => ({ ...prevState, limit: 10, paginationPage: 0, page: 1, filter: search }));
  };

  //tab
  const [tabIndexValue, setValue] = React.useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    setCompanyManagementList([]);
    setPayload((prev) => ({ ...prev, limit: 10, paginationPage: 0, page: 1, filter: null }));
  };

  const handleOnAdd = (value) => {
    setCompanyDetails({ type: 'add' });
    setOpenAddCompany(true);
  };

  const getCompanyList = async () => {
    source.cancel();
    source = CancelToken.source();
    setIsLoading(payload.filter ? false : true);
    // dispatch(setLoading(payload.filter ? false : true));
    let url;
    if (tabIndexValue === 0) {
      url = `company/all/active`;
    } else if (tabIndexValue === 1) {
      url = `company/all/blocked`;
    }
    const response = await appapi.get(
      `${url}`,
      {
        pageNumber: payload.page,
        filter: payload.filter ? payload.filter : null,
        pageSize: payload.limit,
        companyTypeFilter: payload.companyTypeFilter,
        screeningStatusFilter: payload.screeningStatusFilter,
        sortOrderField: payload.field,
        sortOrder: payload.sortOrder,
        entityTypeFilter: payload.entityTypeFilter,
        clientTypeFilter: payload.clientTypeFilter,
      },
      { cancelToken: source.token },
    );

    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        data?.response?.response.map((item, index) => {
          item.Sno = payload.limit * (payload.page === 1 ? 0 : payload.page - 1) + index + 1;
        });
        setCompanyManagementList(data?.response?.response || []);
        setPayload((prev) => ({ ...prev, totalLength: data?.response.length, paginationPage: payload.page === 1 ? 0 : payload.page - 1 }));
        setIsLoading(false);
      } else {
        setPayload((prev) => ({ ...prev, totalLength: 0, paginationPage: 0 }));
        setCompanyManagementList([]);
        setIsLoading(false);
      }
    } else {
      setCompanyManagementList([]);
      setPayload((prev) => ({ ...prev, paginationPage: 1 }));
      // setIsLoading(false);
    }
  };

  useEffect(() => {
    getCompanyList();
    return () => {
      if (source) {
        source.cancel();
      }
    };
    // eslint-disable-next-line
  }, [payload.page, payload.filter, payload.companyTypeFilter, payload.screeningStatusFilter, tabIndexValue, payload.sortOrder, payload.field, payload.entityTypeFilter, payload.clientTypeFilter]);

  const header = () => {
    return (
      <>
        <PageHeader
          headerTittle={`COMPANY MANAGEMENT > ${tabIndexValue === 0 ? 'CURRENT' : 'BLOCKED'} `}
          handleOnSearchEmit={(search) => {
            handleSearchEmit(search);
          }}
          placeholder={'Company Name'}
          userPermission={''}
          handleExcelDownloadEmit={(value) => {
            // handleExcelDownload(value);
          }}
          handleOnAddEmit={(value) => {
            handleOnAdd(value);
          }}
          buttonShowPermission={{
            addItem: tabIndexValue === 0 ? true : false,
          }}
        />
      </>
    );
  };

  return (
    <div className="pb-[16px] px-[16px] pt-[8px] bg-[#FFFFFF]">
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, border: 'none', background: theme.palette.primary.light, color: 'rgba(255, 255, 255, 1)', borderRadius: '5px 5px 0px 0px' }}>
          <Tabs
            indicatorColor="secondary"
            value={tabIndexValue}
            onChange={handleChange}
          >
            <Tab
              className="!capitalize !text-white	"
              label="Current"
              {...a11yProps(0)}
            />
            <Tab
              className="!capitalize !text-white	"
              label="Blocked"
              {...a11yProps(1)}
            />
          </Tabs>
        </Box>
        <TabLayout>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems={'inherit'}
            className="!mb-[-8px]"
            style={{ padding: '0px 0px 8px 0px' }}
          >
            <Stack
              className="w-[100%]"
              style={{ backgroundColor: 'FFFFFF' }}
            >
              {tabIndexValue === 0 ? header() : null}
              {tabIndexValue === 1 ? header() : null}
            </Stack>

            <Stack style={{ backgroundColor: '#FFFFFF' }}>
              <TablePagination
                rowsPerPageOptions={[]}
                count={payload.totalLength ? payload.totalLength : 0}
                rowsPerPage={payload.limit ? payload.limit : 10}
                page={payload.paginationPage ? payload.paginationPage : 0}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </Stack>
          </Stack>

          <TabPanel
            className="!p-[0px]"
            value={tabIndexValue}
            index={0}
          >
            {tabIndexValue === 0 ? (
              <Current
                isLoading={isLoading}
                viewCompany={(det) => {
                  setCompanyDetails(det);
                  setOpenViewCompany(true);
                }}
                applyFilter={(filterData) => {
                  console.log(filterData);
                  if (filterData.type === 'company') {
                    setPayload((prev) => ({ ...prev, paginationPage: 0, page: 1, companyTypeFilter: filterData.value }));
                  } else if (filterData.type === 'entityType') {
                    setPayload((prev) => ({ ...prev, paginationPage: 0, page: 1, entityTypeFilter: filterData.value }));
                  } else if (filterData.type === 'clientType') {
                    setPayload((prev) => ({ ...prev, paginationPage: 0, page: 1, clientTypeFilter: filterData.value }));
                  } else {
                    setPayload((prev) => ({ ...prev, paginationPage: 0, page: 1, screeningStatusFilter: filterData.value }));
                  }
                }}
                applySort={(sort) => {
                  setPayload((prev) => ({ ...prev, paginationPage: 0, page: 1, field: sort.field, sortOrder: sort.order }));
                }}
                updateFilterValues={(updateValue) => {}}
                dataList={companyManagementList || []}
              />
            ) : null}
          </TabPanel>
          <TabPanel
            value={tabIndexValue}
            index={1}
          >
            {tabIndexValue === 1 ? (
              <Blocked
                isLoading={isLoading}
                viewCompany={(det) => {
                  setCompanyDetails(det);
                  setOpenViewCompany(true);
                }}
                applyFilter={(filterData) => {
                  if (filterData.type === 'company') {
                    setPayload((prev) => ({ ...prev, paginationPage: 0, page: 1, companyTypeFilter: filterData.value }));
                  } else if (filterData.type === 'entityType') {
                    setPayload((prev) => ({ ...prev, paginationPage: 0, page: 1, entityTypeFilter: filterData.value }));
                  } else if (filterData.type === 'clientType') {
                    setPayload((prev) => ({ ...prev, paginationPage: 0, page: 1, clientTypeFilter: filterData.value }));
                  } else {
                    setPayload((prev) => ({ ...prev, paginationPage: 0, page: 1, screeningStatusFilter: filterData.value }));
                  }
                }}
                updateFilterValues={(updateValue) => {}}
                dataList={companyManagementList || []}
                applySort={(sort) => {
                  setPayload((prev) => ({ ...prev, field: sort.field, sortOrder: sort.order }));
                }}
              />
            ) : null}
          </TabPanel>
        </TabLayout>
        {openAddCompany ? (
          <AddEditCompany
            companyDetails={{ type: 'add' }}
            onModelHandleClose={(event) => {
              if (event) {
                setPayload((prev) => ({ ...prev, page: 1 }));
                getCompanyList();
              }
              setOpenAddCompany(false);
            }}
            modelOpen={openAddCompany}
          />
        ) : null}
        {/* {openAddCompany ? (
          <AlertDialog
            handleClose={(event) => {
              if (event) {
                // getCompanyManagementList();
              }
              setOpenAddCompany(false);
            }}
            open={openAddCompany}
          />
        ) : null} */}
        {openViewCompany ? (
          <ViewCompany
            onModelHandleClose={(event) => {
              if (event) {
                getCompanyList();
              }
              setOpenViewCompany(false);
            }}
            modelOpen={openViewCompany}
            companyId={companyDetails?._id}
            type={tabIndexValue}
          />
        ) : null}
      </Box>
    </div>
  );
}
